import { omitBy } from 'lodash'
import isEmpty from 'lodash/isEmpty'
import { useRouter } from 'next/router'
import { ActivityOrderField } from 'generated/graphql'

type TUseCheckQueryParamsForRecruitAdsFn = (params: {
  filters: ReturnType<typeof omitBy>
  currentOrderByField: ActivityOrderField
  hasActivities: boolean
}) => {
  isShowNoticeBanner: boolean
}

/**
 * 필터링, 정렬 및 activities 값 존재 여부를 바탕으로 인턴, 채용 배너 표시 가능 여부를 확인하는 훅
 *
 * @param {Object} params - 파라미터 객체
 * @param {ReturnType<typeof omitBy>} params.filters - 적용된 필터 object
 * @param {ActivityOrderField} params.currentOrderByField - 현재 적용된 정렬 필드
 * @param {boolean} params.hasActivities - 공고 존재 여부
 * @returns {{isShowNoticeBanner: boolean}} 공지 배너 표시 여부를 나타내는 boolean 값을 포함한 object
 *
 * @description
 * 모집 공지 배너 노출 조건
 * - 적용된 필터가 없는 경우 허용
 * - page가 1이거나 존재하지 않는 경우 허용
 * - 정렬 필드가 RECENT인 경우 허용
 * - 활동이 존재하는 경우 허용
 */
const useCheckQueryParamsForRecruitAds: TUseCheckQueryParamsForRecruitAdsFn = ({
  filters,
  currentOrderByField,
  hasActivities,
}) => {
  const router = useRouter()
  const { page } = router.query

  const isShowNoticeBanner =
    isEmpty(filters) &&
    (page === '1' || !page) &&
    currentOrderByField === ActivityOrderField.RECENT &&
    hasActivities

  return {
    isShowNoticeBanner,
  }
}

export default useCheckQueryParamsForRecruitAds
